import React from 'react';
import { Check } from 'lucide-react';

export const PLATFORMS = ['Netflix', 'Prime Video', 'Disney+', 'HBO Max', 'Apple TV+', 'Hulu'];

const slug = (p) => p.toLowerCase().replace(/\+/g, 'plus').replace(/\s+/g, '-');

export const PlatformPicker = ({ selected, onChange, disabled }) => {
  const toggle = (p) => {
    const next = selected.includes(p) ? selected.filter((x) => x !== p) : [...selected, p];
    onChange(next);
  };
  return (
    <fieldset data-testid="subscribe-popup-platforms" disabled={disabled} className="text-left">
      <legend className="font-secondary text-xs uppercase tracking-[0.15em] text-gray-400 mb-2">
        My streaming services
      </legend>
      <div className="flex flex-wrap gap-2">
        {PLATFORMS.map((p) => {
          const on = selected.includes(p);
          return (
            <button
              key={p}
              type="button"
              onClick={() => toggle(p)}
              aria-pressed={on}
              data-testid={`subscribe-platform-${slug(p)}`}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-secondary font-bold border transition-colors ${
                on
                  ? 'bg-[#5DADE2]/15 border-[#5DADE2]/60 text-white'
                  : 'bg-transparent border-white/15 text-gray-500 hover:text-gray-300'
              }`}
            >
              {on && <Check className="w-3 h-3" />}
              {p}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
};
